<template>
  <v-sheet class="pa-4 h-100">
    <v-sheet outlined class="rounded overflow-hidden h-100 d-flex flex-column">
      <div
        class="pa-2 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Manage Roles</h3>
        <v-btn v-has="permissions.Roles.Create"  @click="update()" small color="primary"
          ><v-icon left>mdi-plus</v-icon> Add Role
        </v-btn>
        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
        <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
          <v-text-field
            hide-details
            outlined
            v-if="false"
            v-model="options.search"
            dense
            class="search-bar"
            placeholder="Search in roles..."
            clearable
            prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-sheet>
      </div>
      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageText: 'Row/Page',
          itemsPerPageOptions: [15, 30, 50, 100, 200, 300, 400, 500, -1],
        }"
        :headers="roleHeaders"
        :items="entries"
        :options.sync="options"
        :loading="loading"
        :server-items-length="total">
        <template #[`item.name`]="{ item }">
          <v-chip
            style="font-size: 11px; font-weight: 600"
            :key="item.name"
            label
            x-small
            color="deep-purple"
            text-color="white"
            :ripple="false">
            {{ item.name }}
          </v-chip>
        </template>
        <template #[`item.isDefault`]="{ item }">
          <v-chip
            v-if="item.isDefault"
            small
            x-small
            style="font-size: 11px; font-weight: 600"
            color="primary"
            dark
            text-color="gray darken-2">
            <v-icon small left>mdi-check</v-icon>
            Default
          </v-chip>
          <span v-else>
            <v-icon small disabled left>mdi-close</v-icon>
          </span>
        </template>
        <template #[`item.isSystem`]="{ item }">
          <v-chip
            v-if="item.isSystem"
            small
            x-small
            style="font-size: 11px; font-weight: 600"
            color="red"
            text-color="white">
            <v-icon small left>mdi-check</v-icon> System
          </v-chip>
          <span v-else><v-icon small left disabled>mdi-close</v-icon></span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="more-options-menu" dense>
              <v-list-item @click="update(item.id)" dense >
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small>fa-solid fa-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>View</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="!item.isSystem"
                @click="del(item.id)"
                dense
                :disabled="!$has(permissions.Roles.Delete)">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Roles...</p>
          </div>
        </template>
      </v-data-table>
      <EditRole ref="editRole"></EditRole>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import roleHeaders from '@Role/config/role.headers';
  import { mapGetters } from 'vuex';
  import EditRole from '@Role/components/EditRole.vue';
  import permissions from '@Share/config/permissions';
import { $has } from '@/utils';
  export default {
    name: 'role-list',
    props: ['companyId'],
    data() {
      return {
        roleHeaders,
        timerId: null,
        permissions,
      };
    },
    computed: {
      ...mapGetters('ROLE', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
      }),
      options: {
        get() {
          return this.$store.getters['ROLE/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('ROLE/SET_OPTIONS', val);
        },
      },
    },
    methods: {
      $has,
      update(roleItemId = null) {
        this.$refs.editRole.open(roleItemId, true);
      },
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('ROLE/GET');
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('ROLE/GET');
        }, 400);
      },
      del(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Role?',
          title: 'Delete Role',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                return this.$store.dispatch('ROLE/DELETE', id);
              },
            },
          },
        });
      },
    },
    watch: {
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
    },
    components: {
      EditRole,
    },
  };
</script>
